import { auto } from 'angular';
import { Provider } from "@angular/core";

export function locationFactory(i: auto.IInjectorService) {
   return i.get('$location');
}

export const locationProvider = {
   provide: '$location',
   useFactory: locationFactory,
   deps: ['$injector']
};

export function rootScopeFactory(i: auto.IInjectorService) {
   return i.get('$rootScope');
}

export const rootScopeProvider = {
   provide: '$rootScope',
   useFactory: rootScopeFactory,
   deps: ['$injector']
};

export function routeFactory(i: auto.IInjectorService) {
   return i.get('$route');
}

export const routeProvider = {
   provide: '$route',
   useFactory: routeFactory,
   deps: ['$injector']
};

export function logoutServiceFactory(i: auto.IInjectorService) {
   return i.get('logoutService');
}

export const logoutServiceProvider = {
   provide: 'logoutService',
   useFactory: logoutServiceFactory,
   deps: ['$injector']
}

export function templateValueCalculatorFactory(i: auto.IInjectorService) {
   return i.get('template-value-calculator')
}

export const templateValueCalculatorProvider: Provider = {
   provide: 'templateValueCalculator',
   useFactory: templateValueCalculatorFactory,
   deps: ['$injector']
}